import { Breadcrumb, Button, Card, Modal } from "antd";
import profileIcon from "../../assests/images/profile_large.jpg";
import { useState, useCallback, useEffect } from "react";
import { useLocation, useNavigate } from "react-router";
import SendMoneyService from "../../services/send-money.service";
import { AiOutlineLeft } from "react-icons/ai";
import CommonOtp from "../../components/otp";
import { amountFormat } from "../../services/common.service";
import AccountCard from "../../components/account-card";
import { ReactComponent as TitleIcon } from "../../assests/images/transfer.svg";
import OTP from "../../components/otp";
import { ReactComponent as TickIcon } from "../../assests/images/tickIcon.svg";
import { useTranslation } from "react-i18next";
import { ReactComponent as HomeIcon } from "../../assests/images/home-line.svg";

export default function PESALINKPayeeDetails() {
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const location = useLocation();
  const [payeeDetails, setPayeeDetails] = useState({});
  const [deleteVisible, setDeleteVisible] = useState(false);
  const [type, setType] = useState("VIEW");
  const [stage, setStage] = useState(1);
  const [payeeImage, setPayeeImage] = useState("");
  const [otp, setOtp] = useState("");
  const { t } = useTranslation();
  useEffect(() => {
    if (location.state) {
      setType(location.state.type);
      setPayeeDetails(location.state);
      getPayeeImages(location.state);
    }
  }, []);

  const getPayeeImages = useCallback(
    async (payeeDetails) => {
      try {
        const req = {
          accNo: [payeeDetails.beneAccNo],
        };
        setLoader(true);
        const response = await SendMoneyService.getPayeeImages(req);
        if (response.status === 200) {
          setLoader(false);
          setPayeeImage(response.data["data"]["imagesList"][0]?.imageData);
        }
      } catch (error) {
        setLoader(false);
      }
    },
    [payeeDetails]
  );

  const verifyDeletePayee = useCallback(async () => {
    try {
      setLoading(true);
      const response = await SendMoneyService.verifyDeletePayee({
        reqId: payeeDetails?.reqId,
        beneAccNo: payeeDetails?.beneAccNo,
        authType: "A",
        beneType: "PESALINK",
      });
      if (response.status === 200) {
        setLoading(false);
        setStage(2);
      }
    } catch (error) {
      setLoading(false);
    }
  }, [payeeDetails]);

  const deletePayeeConfirm = useCallback(
    async (values) => {
      try {
        setLoader(true);
        const response = await SendMoneyService.deletePayeeConfirm({
          ...values,
          reqId: payeeDetails?.reqId,
          beneType: "PESALINK",
          authType: "A",
        });
        if (response.status === 200) {
          setLoader(false);
          setMessage(response.data["message"]);
          setDeleteVisible(true);
        }
      } catch (error) {
        setOtp("");
      }
    },
    [payeeDetails]
  );

  function renderSwitch() {
    switch (stage) {
      case 1:
        return renderForm();

      case 2:
        return (
          <OTP
            otp={otp}
            setOtp={setOtp}
            onConfirm={(values) =>
              deletePayeeConfirm({
                reqId: payeeDetails?.reqId,
                beneAccNo: payeeDetails?.beneAccNo,
                ...values,
              })
            }
            handleResendOtp={() => verifyDeletePayee()}
            cancelTransaction={() => {
              setStage(1);
            }}
          />
        );

      default:
        return renderForm();
    }
  }

  function renderForm() {
    return (
      <>
        <div className="row profile-details">
          <div align="center">
            {payeeImage !== null && payeeImage?.length > 0 ? (
              <img
                src={payeeImage}
                alt="Profile"
                height={120}
                width={120}
                style={{ backgroundColor: "#108ee9" }}
              />
            ) : (
              <img src={profileIcon} alt="Profile" height={120} />
            )}
          </div>

          <div className="row">
            <div className="confirm-label-wrapper">
              <label>
                {t("pages.Add_Bene.bane_name", {
                  defaultValue: "Beneficiary Name",
                })}{" "}
              </label>
              <span>{payeeDetails?.beneName || "-"}</span>
            </div>

            <div className="confirm-label-wrapper">
              <label>
                {t("common.account_no_lbl", {
                  defaultValue: "Account Number",
                })}
              </label>
              <span> {payeeDetails?.beneAccNo || "-"}</span>
            </div>
            <div className="confirm-label-wrapper">
              <label>
                {t("pages.Add_Bene.bene_nick_name", {
                  defaultValue: "Beneficiary Nick Name",
                })}
              </label>
              <span>{payeeDetails?.beneNickName || "-"}</span>
            </div>

            <div className="confirm-label-wrapper">
              <label>
                {t("pages.sendMoney.payee.bank_name", {
                  defaultValue: "Bank Name",
                })}
              </label>
              <span>{payeeDetails?.bankName || "-"}</span>
            </div>

            <div className="confirm-label-wrapper">
              <label>
                {t("pages.standing_instruction.branch_code", {
                  defaultValue: "Branch Code",
                })}
              </label>
              <span>{payeeDetails?.beneBrn || "-"}</span>
            </div>

            <div className="confirm-label-wrapper">
              <label>
                {t("pages.transfer_limit.transfer_limit", {
                  defaultValue: "Transfer Limit",
                })}
              </label>
              <span>
                {amountFormat(
                  payeeDetails?.maxTransferLimit,
                  payeeDetails?.beneCurrency
                )}
              </span>
            </div>
          </div>
        </div>
        {type === "DELETE" && (
          <p style={{ marginTop: 30, fontSize: 15 }}>
            {t("pages.Add_Bene.delete_txt", {
              defaultValue:
                "Note : If you proceed, any scheduled transfers to this beneficiary will also get deleted",
            })}
          </p>
        )}

        {type === "VIEW" && (
          <div className="mt-5 payee-details-btn-group" align="right">
            <Button
              className="secondary-btn mx-5"
              onClick={() =>
                navigate(
                  "/beneficiary-management/pesaLink-beneficiary-modify",
                  {
                    state: { ...payeeDetails, mode: "MODIFY" },
                  }
                )
              }
              size="large"
            >
              {t("pages.Add_Bene.modify_beneficiary", {
                defaultValue: "Modify Beneficiary",
              })}
            </Button>
            <Button
              onClick={() => setType("DELETE")}
              danger
              size="large"
              className="mt-2"
            >
              {t("pages.Add_Bene.delete_beneficiary", {
                defaultValue: "Delete Beneficiary",
              })}
            </Button>
          </div>
        )}

        {type === "DELETE" && (
          <div className="mt-5 payee-details-btn-group d-flex justify-content-end">
            <Button
              style={{ marginRight: 20 }}
              onClick={() =>
                type === location.state?.type
                  ? navigate("/pesaLink/manage-beneficiary")
                  : setType("VIEW")
              }
              size="large"
              className="secondary-btn"
            >
              {t("buttons.cancel_btn", {
                defaultValue: "Cancel",
              })}
            </Button>
            <Button
              type="primary"
              onClick={() => verifyDeletePayee()}
              // loading={loading}
              size="large"
              className="primary-btn mx-3"
            >
              {t("buttons.proceed_btn", {
                defaultValue: "Proceed",
              })}
            </Button>
          </div>
        )}
      </>
    );
  }
  return (
    <>
        <Breadcrumb separator=">">
          {/* <Breadcrumb.Item>
            <span onClick={() => navigate("/dashboard")}>
              <HomeIcon height={14}/>
            </span>
          </Breadcrumb.Item> */}
          <Breadcrumb.Item>
            <span onClick={() => navigate("/pesaLink")}>
              Pesalink
            </span>
          </Breadcrumb.Item>
          <Breadcrumb.Item
            onClick={() => navigate("/pesaLink/manage-beneficiary")}
          >
            <span>
              {t("pages.Add_Bene.manage_beneficiaries", {
                defaultValue: "Manage Beneficiaries",
              })}
            </span>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span>
            Pesalink Beneficiary
            
            </span>
          </Breadcrumb.Item>
        </Breadcrumb>
      <Card size="small" className="mb-1 text-center breadcrumb-title-card">
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex justify-content-left align-items-center heading mx-0">
            {/* <TitleIcon height={30} style={{ marginLeft: "-20px" }} /> */}
            <h3 className="title mb-0">
              {" "}
              {t("pages.Add_Bene.manage_beneficiaries", {
                defaultValue: "Manage Beneficiaries",
              })}
            </h3>
          </div>
        </div>
      </Card>
      <div className="row d-flex justify-content-between">
        <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4 hide-xs">
          <Card className="application-card"  >
            <AccountCard />
          </Card>
        </div>
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-8 col-xl-8">
          {" "}
          <div className="row">
            <div>
              <Card className="application-card card-padding">
                {renderSwitch()}
              </Card>
            </div>
          </div>
        </div>
      </div>

      <Modal
        title=""
        open={deleteVisible}
        footer={null}
        width={480}
        closable={false}
        maskClosable={false}
        mask={true}
      >
        <div style={{ width: 350, margin: "0 auto" }} align="center">
          <TickIcon height={65} />
          <h4 className="mb-3 mt-2">
            {" "}
            {t("common.success", {
              defaultValue: "Success",
            })}
          </h4>
          <p>{message}</p>

          <div align="center">
            <Button
              type="primary"
              size="large"
              style={{ width: 130 }}
              onClick={() => {
                setDeleteVisible(false);
                navigate("/pesaLink/manage-beneficiary");
              }}
            >
              {t("buttons.okay_btn", {
                defaultValue: "Okay",
              })}
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
}
